import React from 'react';
import useDocumentTitle from '../../../hooks/useDocumentTitle';
import SBCreditNoteForm from '../components/SBCreditNoteForm';
import { useLocation, useNavigate } from 'react-router-dom';
import { Stack } from '@mui/material';
import { useCreateCreditNoteHandler } from '../../creditNotes/dataHandlers/createCreditNoteHandler';

export default function CreateSBCreditNotePage() {
  useDocumentTitle('Self Billed Credit Notes Form');
  const navigate = useNavigate();
  const location = useLocation();
  const document = location.state.document;

  const onCreditNoteCreated = (payload) => {
    if (payload.status === 'draft') {
      navigate('/self-billed-drafts?tab=self-billed-credit-notes');
    } else {
      navigate('/self-billed-documents?tab=self-billed-credit-notes');
    }
  };

  const { onSubmit, error } = useCreateCreditNoteHandler({ onSuccess: onCreditNoteCreated });

  const onSaveAsEInv = async (data) => {
    const payload = {
      ...data,
      status: 'active',
    };

    await onSubmit(payload, data.status);
  };

  const onSaveAsDraft = async (data) => {
    const payload = {
      ...data,
      status: 'draft',
    };

    await onSubmit(payload, data.status);
  };

  const onCancel = async () => {
    navigate(location.state?.from || '/self-billed-documents?tab=self-billed-credit-notes');
  };

  return (
    <Stack direction="column" sx={{ mt: '-2rem' }}>
      <SBCreditNoteForm
        initialData={document || {}}
        onSubmit={onSaveAsEInv}
        onSaveDraft={onSaveAsDraft}
        onCancel={onCancel}
        apiErrors={error}
      />
    </Stack>
  );
}
